export default async function ({ store, redirect, route }) {
  if (route.query.uid && route.query.event) {
    console.log(
      `FROM_MAIL_EVENT_INF_DASHBOARD ${route.query.uid} ${route.query.event}`
    )
    return redirect("/")
  }
  if (!store.getters["user/IS_INF"]) {
    return redirect("/")
  } else {
    await Promise.all([
      store.dispatch("tag/FETCH"),
      store.dispatch("user/influencer/tags/FETCH"),
    ])
  }
}
